import { useState } from 'react';
import { cn } from '@jk-core/utils';
import styles from './SwitchButton.module.scss';

interface SwitchButtonProps {
  /**
   * 스위치 버튼의 상태를 나타냅니다.
   * true이면 스위치가 켜진 상태, false이면 꺼진 상태입니다.
   * 기본값은 false로 설정되어 있습니다.
   */
  checked?: boolean,
  /**
   * 스위치 버튼의 상태가 변경될 때 호출되는 함수입니다.
   */
  onChange?: (value: boolean) => void
}

/**
 * SwitchButton 컴포넌트
 * 스위치 버튼을 표시하며, 클릭 시 상태가 변경됩니다.
 * checked 속성으로 초기 상태를 설정할 수 있으며, onChange 함수를 통해 상태 변경을 처리할 수 있습니다.
 */
export default function SwitchButton({ checked = false, onChange = () => { } }: SwitchButtonProps) {
  const [isChecked, setIsChecked] = useState(checked);

  return (
    <button
      className={styles.button}
      type="button"
      onClick={() => {
        setIsChecked(!isChecked);
        onChange(!isChecked);
      }}
    >
      <div
        className={cn({
          [styles.switch]: true,
          [styles.switch__off]: checked,
        })}
      >
        <div className={cn({
          [styles.switch__button]: true,
          [styles['switch__button--off']]: !checked,
          [styles['switch__button--on']]: checked,
        })}
        >
          <div className={cn({
            [styles['switch__button--circle']]: true,
            [styles['switch__button--circle-on']]: checked,
          })}
          />
        </div>
      </div>
    </button>
  );
}
